import { Box, Icon } from '@chakra-ui/react';
import { LucideMail, LucideMailOpen } from 'lucide-react';

export function NotificationMailIcon({ read }: { read: boolean }) {
  return (
    <Box
      position='relative'
      _after={
        read
          ? {}
          : {
              content: '""',
              position: 'absolute',
              top: '1px',
              right: '-2px',
              width: '6px',
              height: '6px',
              zIndex: '1',
              borderRadius: '50%',
              backgroundColor: 'red.500',
            }
      }
    >
      <Icon
        position='relative'
        as={read ? LucideMailOpen : LucideMail}
        boxSize={4}
        color='white'
      />
    </Box>
  );
}
